import Spinner from "components/Spinner";
import React from "react";
import { twMerge } from "tailwind-merge";

export default function Button({ children, isLoading = false, ...props }) {
  return (
    <button
      {...props}
      disabled={props.disabled || isLoading}
      className={twMerge(
        "px-8 py-2 rounded font-semibold text-center bg-violet-500 hover:bg-violet-500 custom-focus cursor-pointer flex justify-center items-center gap-3 disabled:opacity-80",
        props.className
      )}
    >
      {isLoading && <Spinner className="flex-grow-0 w-5 h-5" />}
      {children}
    </button>
  );
}
